module.exports = __webpack_public_path__ + "img/VOLVO.50ed9987.svg";